import ShopsDB, { ShopEntity, ShopMenuEntity } from 'src/firebase/db/Shops';
import { ShopBagEntity } from 'src/firebase/db/ShopBags';

/**
 *　店舗一覧を取得
 */
export const getShops = () => {
  return ShopsDB.getShops();
};

/**
 *　店舗を取得
 */
export const getShop = (document_id: string) => {
  return ShopsDB.getShop(document_id);
};

/**
 * 店舗を作成する
 */

export const createShop = (query: ShopEntity) => {
  console.log('createShop', query);
  return ShopsDB.create(query);
};

/**
 * 店舗を編集する
 */

export const updateShop = (query: ShopEntity) => {
  console.log('updateShop', query);
  return ShopsDB.update(query);
};

/**
 * レジ袋情報を更新する
 */
export const updateShopBags = (id: string, query: ShopBagEntity[]) => {
  return ShopsDB.updateBags(id, query);
};

/**
 * 店舗メニューを作成する
 */
export const createShopMenu = (doc_id: string, query: ShopMenuEntity) => {
  console.log('createShopMenu', doc_id, query);
  return ShopsDB.addMenus(doc_id, query);
};

/**
 * 店舗メニューを作成する
 */
export const updateShopMenu = (doc_id: string, menu_id: string, query: ShopMenuEntity) => {
  console.log('createShopMenu', doc_id, menu_id, query);
  return ShopsDB.updateMenus(doc_id, menu_id, query);
};

/**
 * メール送信先を登録する
 */
export const addMailSenders = (doc_id: string, address: string) => {
  console.log('AddMailSenders', doc_id, address);
  return ShopsDB.updateOwnersMailSenders(doc_id, 'add', address);
};

/**
 * メール送信先を削除する
 */
export const deleteMailSenders = (doc_id: string, address: string) => {
  console.log('DeleteMailSenders', doc_id, address);
  return ShopsDB.updateOwnersMailSenders(doc_id, 'delete', address);
};
